import { Component, Inject } from '@angular/core';
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';
import { LoggerService } from "../../shared/logger.service";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Eintrag } from '../eintrag/eintrag.model';
import { AngularMaterial2Module } from '../../app.module.material';
import { FlexModule } from '@ngbracket/ngx-layout';

const PATH_FILE = 'app/protected/kategorieeintrag/kategorieeintragdialog.component.ts';

@Component({
  selector: 'kategorieeintragdialog',
  templateUrl: './kategorieeintragdialog.component.html',
  styleUrls: ['./kategorieeintrag.component.css'],
  standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]
})
export class KategorieEintragDialogComponent {
  public OBJ_LNG_NAME = "kategorieeintrag"; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
  name: string = '';
  subject: string;
  question: string;
  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
	  @Inject(L10N_CONFIG) private config: L10nConfig,
    public translation: L10nTranslationService,
    public _logger: LoggerService,
    @Inject(MAT_DIALOG_DATA) public data: { entry: Eintrag, injSubject: string, injQuestion: string}) {
      this.name = data.entry.text;
      this.subject=data.injSubject;
      this.question=data.injQuestion;
    }
}
